import React, { lazy, useEffect, useState, Suspense } from "react";
import { useLocation } from "react-router-dom";
// import AppRoute from "./route";
import Layout from "../container/layout";
import AdminLayout from "../container/adminContainer/AdminLayout";
import PublicSchoolcontainer from "../container/publicShoolContainer";
import ResetPasswordAdmin from "../container/adminContainer/resetPassword";
import { Route, Routes, Navigate } from "react-router-dom";



const LoginPage = lazy(() => import("../pages/loginPage"));
const IncomeCertificateDetails = lazy(() => import("../pages/registrationPage/incomeDetailsPage"));
const AadhaarDetailsPage = lazy(() => import("../pages/registrationPage/aadhaarDetailsPage"));
const FinalEditSubmitPage = lazy(() => import("../pages/finalEditSubmitPage"));
const PrintAcknowledgementContainer = lazy(() => import("../pages/printAcknowledgementPage"));
const StudentDetailsPage = lazy(() => import("../pages/registrationPage/studentDetailsPageTwo"));
const MentionChildPage = lazy(() => import("../pages/registrationPage/mentionChildPage"));
const NotificationPage = lazy(() => import("../pages/notificationPage"));
const SearchSchoolPage = lazy(() => import("../pages/searchSchoolPage"));
const StudentApplicationStatusPage = lazy(() => import("../pages/studentApplicationStatusPage"));

// Admin Panel
const AdminLoginPage = lazy(() => import("../pages/adminPages/AdminLoginPage"));
const DashboardPage = lazy(() => import("../pages/adminPages/dashboardPage"));
const StudentListPage = lazy(() => import("../pages/adminPages/studentListPage"));
const StudentDetailsPageTwo = lazy(() => import("../pages/adminPages/studentDetailsPage"));
const StateAdminDashboardPage = lazy(() => import("../pages/adminPages/stateAdminDashboardPage"));
const DistrictListPage = lazy(() => import("../pages/adminPages/districtListPage"));
const BlockListPage = lazy(() => import("../pages/adminPages/blockListPage"));
const SchoolListPage = lazy(() => import("../pages/adminPages/schoolListPage"));
const RandomizationPage = lazy(() => import("../pages/adminPages/randomizationPage"));
const ToPrint = lazy(() => import("../container/adminContainer/randomizationContainer/toPrint"));
const DashboardPageAdmin = lazy(() => import("../pages/adminPages/dashboardPageAdmin"));
const UserIdWiseStatusPage = lazy(() => import("../pages/adminPages/userIdWiseStatusPage"));
const SchoolEntry = lazy(() => import("../pages/adminPages/schoolEntry"));
const SchoolListForDistrict = lazy(() => import("../pages/adminPages/schoolListForDistrict"));
const SchoolEntryStatusDistrict = lazy(() => import("../container/adminContainer/schoolEntryStatusDistrict"));
const Report = lazy(() => import("../container/reports"));
//v2 Routes
const StudentListContainerV2 = lazy(() => import("../v2/container/studentListContainer/index"));
const StudentDetailsContainerV2 = lazy(() => import("../v2/container/studentDetailsContainer/index"));
const BlockListContainerV2 = lazy(() => import("../v2/container/DEOContainer/blockListContainer/index"));
const DistrictListContainerV2 = lazy(() => import("../v2/container/stateContainer/districtListContainer/index"));
const SchoolStudentListV2 = lazy(() => import("../v2/container/schoolStudentList/index"));
const BlockSchoolListContainerV2 = lazy(() => import("../v2/container/BEOContainer/BEOSchoolwiseContainer"));
const BlockStudentListContainerV2 = lazy(() => import("../v2/container/BEOContainer/Students/BEOSchoolWiseStudent"));

const openRoutes = [
    { path: "/", exact: true, component: LoginPage },
    { path: "/registration/student-details", exact: true, component: StudentDetailsPage },
    { path: "/registration/income-certificate-details", exact: true, component: IncomeCertificateDetails },
    { path: "/registration/aadhaar-details", exact: true, component: parseInt(process.env.REACT_APP_RESISTRATION) === 1 ? AadhaarDetailsPage : LoginPage },
    { path: "/registration/final-edit-submit", exact: true, component: FinalEditSubmitPage },
    { path: "/registration/student-details-two", exact: true, component: StudentDetailsPage },
    { path: "/print-acknowledgement", exact: true, component: PrintAcknowledgementContainer },
    { path: "/registration/choose-child", exact: true, component: MentionChildPage },
    { path: "/admin", exact: true, component: AdminLoginPage },
    { path: "/registration/notification", exact: true, component: NotificationPage },
    // { path: "/admin/search-school", exact:true, component: SearchSchoolPage },  //  /admin will be removed 
    // { path: "/admin/check-application-status", exact: true, component: StudentApplicationStatusPage },
    { path: "/admin/final-report/:session", exact: true, component: ToPrint },
    { path: "/registration/school-details-page", exact: true, component: PublicSchoolcontainer },
    { path: "/*", exact: true, navigate: "/" },

];

const adminAuthRoutes = [
    { path: "/admin/dashboard-admin", exact: true, component: DashboardPageAdmin },
    // v2 dashboard state admin
    { path: "/admin/dashboardV2-admin", exact: true, component: DistrictListContainerV2 },
    { path: "/admin/dashboard", exact: true, component: DashboardPage },
    { path: "/admin/school-entry", exact: true, component: SchoolEntry },
    { path: "/admin/student-list", exact: true, component: StudentListPage },
    //school v2 student list
    { path: "/admin/school-student-list", exact: true, component: SchoolStudentListV2 },
    { path: "/admin/student-details", exact: true, component: StudentDetailsPageTwo },
    //v2 student details page
    { path: "/admin/studentv2-details", exact: true, component: StudentDetailsContainerV2 },

    { path: "/admin/state-dashboard", exact: true, component: StateAdminDashboardPage },
    { path: "/admin/district-list", exact: true, component: DistrictListPage },
    { path: "/admin/block-list", exact: true, component: BlockListPage },
    // admin v2 block list
    { path: "/admin/blockv2-list", exact: true, component: BlockListContainerV2 },
    { path: "/admin/school-list", exact: true, component: SchoolListPage },
    { path: "/admin/schoolv2-list", exact: true, component: BlockSchoolListContainerV2 },
    { path: "/admin/studentv2-list", exact: true, component: BlockStudentListContainerV2 },
    //v2 school route for beo
    { path: "/admin/school-v2", exact: true, component: StudentListContainerV2 },
    { path: "/admin/randomization", exact: true, component: RandomizationPage },
    { path: "/admin/dashboard/school-wise-status", exact: true, component: UserIdWiseStatusPage },
    { path: "/admin/school-list-for-district", exact: true, component: SchoolListForDistrict },
    { path: "/admin/school-entry-district", exact: true, component: SchoolEntryStatusDistrict },
    { path: "/admin/report-list", exact: true, component: Report },
    { path: "/admin/reset-password", exact: true, component: ResetPasswordAdmin },
    { path: "/admin/final-report/:session", exact: true, component: ToPrint },
    { path: "/*", exact: true, navigate: "/admin/dashboard-admin" },

];

const PagesRoute = (props) => {
    const [allRoutes, setAllRoutes] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const authStatus = true;
        setIsAuthenticated(authStatus);
    }, []);

    useEffect(() => {
        setAllRoutes([...openRoutes]);
    }, []);

    const generateRoute = (allRoutes) => {
        let _data = [];
        allRoutes.map(({ path, component: Component, navigate, ...route }, i) => {
            _data.push(
                <Route
                    path={path}
                    key={i}
                    exact={true}
                    element={
                        navigate ? (
                            <Navigate replace to={navigate} />
                        ) : (
                            <Suspense fallback={<></>}>
                                <Component />
                            </Suspense>
                        )
                    }
                />
            );
        });
        return <Routes>{_data}</Routes>;
    };


    return (
        <>
            {(location.pathname === "/" || location.pathname === "/admin" || location.pathname.startsWith("/registration") || location.pathname === "/print-acknowledgement") && (
                <Layout>
                    {generateRoute(allRoutes)}
                </Layout>
            )}
            {location.pathname.startsWith("/admin") && (
                <div>
                    {isAuthenticated && (location.pathname !== "/admin" && location.pathname !== "/admin/final-report") && (
                        <AdminLayout>
                            {generateRoute(adminAuthRoutes)}
                        </AdminLayout>
                    )}
                </div>
            )}
        </>
    );
};

export default PagesRoute;